import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/api';
import { Table } from 'primeng/table';
import { AdicionalEDesconto } from 'src/app/admihair/api/dto/adicional-e-desconto';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { AdicionalEDescontoService } from 'src/app/admihair/service/adicional-e-desconto.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';

@Component({
  selector: 'app-adicionais-e-descontos-listar',
  templateUrl: './adicionais-e-descontos-listar.component.html',
  styleUrls: ['./adicionais-e-descontos-listar.component.scss']
})
export class AdicionaisEDescontosListarComponent extends AdmihairBaseComponent implements OnInit {

  loading: boolean = true;
  empresaSelecionada?: Empresa;
  profissionais: Profissional[] = [];
  filtroDataRegistro?: Date;
  adicionaisEDescontos: AdicionalEDesconto[] = [];

  constructor(private adicionalEDescontoService: AdicionalEDescontoService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService) {
      super(erroService, utilStorageService)
     }

  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    this.inicializarCompetenciaAtual();
    if (this.permissaoListar) {
      this.carregar(); 
    }
  }

  inicializarCompetenciaAtual(){
    const now = new Date()
    this.filtroDataRegistro = new Date(now.getFullYear(), now.getMonth(), 1);
  }

  carregar(){
    this.adicionalEDescontoService.listarPorEmpresaIdComFiltros(this.empresaSelecionada?.id, this.filtroDataRegistro).subscribe({
      next: (data: AdicionalEDesconto[]) => {
        this.adicionaisEDescontos = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    });

  }

  listarComFiltros(){
    this.loading = true;
    this.adicionalEDescontoService.listarPorEmpresaIdComFiltros(this.empresaSelecionada?.id, this.filtroDataRegistro).subscribe({
      next: (data: AdicionalEDesconto[]) => {
        this.adicionaisEDescontos = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    });
  }


  excluir(id: number){
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.adicionalEDescontoService.excluir(id).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.carregar();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        })
        
      }
    });
  }


  editar(id: number) {
    this._router.navigate(["/apps/adicionais-e-descontos/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalhar(id: number) {
    this._router.navigate(["/apps/adicionais-e-descontos/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_ADICIONAIS_E_DESCONTOS');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_ADICIONAIS_E_DESCONTOS');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_ADICIONAIS_E_DESCONTOS');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_ADICIONAIS_E_DESCONTOS');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_ADICIONAIS_E_DESCONTOS');
  }

}
